import { render } from "./RecentBookings.vue?vue&type=template&id=7d12b324&scoped=true&ts=true"
import script from "./RecentBookings.vue?vue&type=script&lang=ts"
export * from "./RecentBookings.vue?vue&type=script&lang=ts"

import "./RecentBookings.vue?vue&type=style&index=0&id=7d12b324&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d12b324"]])

export default __exports__